<template>
  <v-otp-input
    v-model="fieldValue"
    :length="length"
    :type="type"
    :variant="variant"
    :divider="divider"
    :width="width"
    :rounded="rounded"
    :placeholder="placeholder"
    :label="label"
    :autofocus="autofocus"
    :rules="rules"
    :readonly="readonly"
    :disabled="disabled"
    :error="!!errors"
    :focused-field="focusedField"
    class="otp-input"
    @blur="blur"
    @update:model-value="onUpdate"
  />
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  label?: string;
  type?: "text" | "password" | "number";
  variant?:
    | "underlined"
    | "outlined"
    | "filled"
    | "solo"
    | "solo-inverted"
    | "solo-filled"
    | "plain";
  divider?: string;
  width?: string | number;
  rounded?:
    | "xs"
    | "sm"
    | "lg"
    | "xl"
    | "pill"
    | "circle"
    | "shaped"
    | true
    | false;
  placeholder?: string;
  length?: number;
  autofocus?: boolean;
  rules?: ((value: string) => boolean | string)[];
  readonly?: boolean;
  disabled?: boolean;
  blur?: () => void;
  focusedField?: number;
}

// Define the props with default values
const props = withDefaults(defineProps<Props>(), {
  label: "",
  type: "text",
  variant: "underlined",
  divider: "",
  width: "100%",
  placeholder: "",
  rounded: "xs",
  length: 4,
  autofocus: true,
  rules: () => [],
  blur: () => {},
  focusedField: 0,
});

const emit = defineEmits<(e: "update:model-value", value: string) => void>();

// Initialize field using vee-validate
const {
  value: fieldValue,
  errorMessage: errors,
  setValue,
} = useField<string>(props.name);

const onUpdate = (newValue: string) => {
  setValue(newValue);
  emit("update:model-value", newValue);
};
</script>
